import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES, TARGETS } from 'app-webtech-core/beacon/const';
import { getPlaybackData } from './helpers/getPlaybackData';

/*
Fires when there is an error loading/playing the video (at any point during the User's session).
 */
export const videoErrorBeacon = ({ payload }, prevState, nextState) => ({
  hitType: HIT_TYPE.EVENT,
  targets: [TARGETS.PLUTO, TARGETS.MSN],
  label: (payload && payload.message) || 'Generic Error',
  eventCategory: EVENT_CATEGORIES.QOS,
  eventName: EVENT_NAMES.VIDEO_ERROR,
  ...getPlaybackData(nextState),
});
